module.exports = __webpack_public_path__ + "img/12.2f48dac4.jpg";